import CustomLayout from "./wrapper"

export const wrapPageElement = CustomLayout
